import { loadMailFolders } from 'owa-mail-folder-store';
import { conversationCache, mailStore } from 'owa-mail-store';
import deleteConversationItemParts from 'owa-mail-store-actions/lib/actions/deleteConversationItemParts';

export default function initializeMailDeeplinkModuleState(): void {
    // Passing a delegate here as the delete callback to allow deleteConversationItemParts to be fully loaded by webpack.
    conversationCache.initialize(mailStore.conversations, key => {
        deleteConversationItemParts(key);
    });

    loadMailFolders();
}
